import { getStateFromPath } from "@react-navigation/native";

import type { CutoverRoutes } from "@marta/core/features/cutover/forwarding";

import { authV2NavConfig } from "../../navigation/auth-v2/nav-config";
import { preLoginNavScreens } from "../../navigation/root/pre-login-nav-config";

// What the cut-over gate needs to know about this app's routes, read off the
// same linking config react-navigation routes by, so the two cannot drift.
// Kept free of screens: it is loaded with the app shell, before the
// navigation bundle.

const trimSlashes = (path: string) => path.replace(/^\/+|\/+$/g, "");

/**
 * The route a signed-out visitor is sent to from a screen that needs a
 * session. The root navigator swaps the signed-in app stack for the sign-in
 * stack, which opens on its initial route.
 */
const signInPath = (() => {
  const initial = authV2NavConfig.initialRouteName;
  const entry = initial ? authV2NavConfig.screens?.[initial] : undefined;
  const path = typeof entry === "string" ? entry : entry?.path;

  return trimSlashes(path ?? "");
})();

export const cutoverRoutes: CutoverRoutes = {
  isAuthBounce: (rest) => signInPath !== "" && trimSlashes(rest) === signInPath,

  // Matched the way react-navigation itself would match the path, against
  // only the part of the root config that is served without a session. A
  // path the signed-in app stack serves — or one this app does not know at
  // all — is not pre-login, and an anonymous visitor on it stays here.
  isPreLogin: (rest) => {
    const path = trimSlashes(rest);

    return (
      path !== "" &&
      getStateFromPath(path, { screens: preLoginNavScreens }) !== undefined
    );
  },
};
